module.exports = __webpack_public_path__ + "static/logo-d3a577bc8a5b0c32fc0ccf4db8c8b04d.png";